import { render, staticRenderFns } from "./leftTree.vue?vue&type=template&id=dcc31ddc&scoped=true&"
import script from "./leftTree.vue?vue&type=script&lang=js&"
export * from "./leftTree.vue?vue&type=script&lang=js&"
import style0 from "./leftTree.vue?vue&type=style&index=0&id=dcc31ddc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc31ddc",
  null
  
)

export default component.exports